<template>
  <vue-recaptcha
    ref="recaptcha"
    size="invisible"
    :sitekey="googleRecaptchaKey"
    @verify="recaptchaSuccess"
    @expired="resetCaptcha"
    @error="resetCaptcha"
  />
</template>

<script>
import { googleRecaptchaKey } from 'src/config'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'Recaptcha',
  components: {
    VueRecaptcha
  },
  emits: ['reset', 'success'],
  created () {
    _.extend(this, { googleRecaptchaKey })
  },
  methods: {
    resetCaptcha (notify = true) {
      this.$refs.recaptcha.reset()
      if (notify) {
        this.$emit('reset')
      }
    },
    error () {
      this.resetCaptcha()
    },
    executeCaptcha () {
      this.$refs.recaptcha.execute()
    },
    recaptchaSuccess (token) {
      this.$emit('success', token)
      this.$refs.recaptcha.reset()
    }
  }
}

</script>
